import InputTextField from './InputTextField.jsx';

export default function FormInputTextField({
	label,
	 type, 
	 name,
	 value,
	 placeholder,
	 disabled,
	 required,
	 onChange,
	 labelRequire=true,
	 className,
}) {
	return (
		<>
			<InputTextField
				label={label}
				name={name}
				value={value}
				type={type}
				placeholder={placeholder}
				disabled={disabled} 
				required={required} 
				onChange={onChange}
				labelRequire={labelRequire}
				className={className}
			/>
		</>
	)
}
